export const getItem = async (kind: string, id: string) => {
	const res = await fetch(
		`${process.env.NEXT_PUBLIC_BASE_URL}/api/content/${kind}/${id}`,
		{
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-store",
		},
	);

	if (!res.ok) throw new Error("Failed to fetch Item");
	return res.json();
};
